/**
 * Main Store
 *
 * @author minkyoung.park@emcast.com
*/
import Vue from 'vue'
import Vuex from 'vuex'
import findId from './modules/findIdStore'
import findPw from './modules/findPwStore'
import join from './modules/joinStore'
import sales from './modules/salesStore'
import social from './modules/socialStore'
import loginApi from '@/api/loginApi.js'
import learn from './modules/learnStore'


Vue.use(Vuex)

const state = {
    languageMode: 'ltr'
}

const mutations = {
    SET_LANGUAGE_MODE(state, value) {
        state.languageMode = value
    },
}

const getters = {

}

const actions = {

}

const store = new Vuex.Store({
    state,
    mutations,
    getters,
    actions,
    modules: {
        findId,
        findPw,
        join,
        sales,
        social,
        learn
    }
})

const { token } = localStorage
if (token) {
    loginApi.setAuthInHeader(token)
}

export default store